import axios, { AxiosRequestConfig } from "axios";

interface RequestConfig extends AxiosRequestConfig {
  includeReferrerUrlHeader?: boolean;
}

export async function request<T>(options: RequestConfig): Promise<T> {
  const client = axios.create({
    baseURL: site.baseUrl,
    headers: {
      "X-Referrer-Url": window.location.href,
    },
  });

  if (options?.includeReferrerUrlHeader === false) {
    delete client.defaults.headers["X-Referrer-Url"];
  }

  const result = await client(options);
  return result.data;
}
